<div
  class="w-full mx-auto min-h-screen p-5 bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-blue-900/20">

  <!-- Loading State -->
  <div *ngIf="loading" class="flex items-center justify-center py-20">
    <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-600"></div>
  </div>

  <div *ngIf="!loading && request" class="space-y-6 animate-fade-in">
    <!-- Header with Back Button -->
    <div class="flex items-center gap-4 mb-6">
      <button (click)="goBack()"
        class="flex items-center justify-center h-10 w-10 rounded-lg bg-white border border-gray-300 hover:bg-gray-50 transition-colors dark:bg-boxdark dark:border-strokedark dark:hover:bg-gray-800">
        <svg class="h-5 w-5 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <div class="flex-1">
        <div class="flex items-center gap-3 mb-1">
          <h1 class="text-3xl font-bold text-gray-900 dark:text-white">Detalle de Solicitud</h1>
          <!-- Badge de tipo (Entrada/Salida) -->
          <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium"
            [ngClass]="getRequestTypeBadgeClass(request.requestType)">
            <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                [attr.d]="getRequestTypeIcon(request.requestType)" />
            </svg>
            {{ getRequestTypeName(request.requestType) }}
          </span>
        </div>
        <p class="text-gray-600 dark:text-gray-300">Lead ID: <span class="font-mono font-semibold">{{ request.leadId
            }}</span></p>
      </div>
    </div>

    <!-- Status Card -->
    <div
      class="rounded-2xl border border-stroke bg-gradient-to-br from-white to-gray-50 p-8 shadow-xl dark:border-strokedark dark:from-boxdark dark:to-gray-900/50">
      <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div class="flex items-center">
          <div class="mr-4 flex h-16 w-16 items-center justify-center rounded-full shadow-lg" [ngClass]="{
                 'bg-gradient-to-br from-yellow-400 to-yellow-600': request.status === BitrixRequestStatus.Pending,
                 'bg-gradient-to-br from-blue-400 to-blue-600': request.status === BitrixRequestStatus.Processing,
                 'bg-gradient-to-br from-green-400 to-green-600': request.status === BitrixRequestStatus.Success,
                 'bg-gradient-to-br from-red-400 to-red-600': request.status === BitrixRequestStatus.Failed
               }">
            <svg class="h-8 w-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                [attr.d]="request.status === BitrixRequestStatus.Success ? 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' : request.status === BitrixRequestStatus.Failed ? 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z' : 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'" />
            </svg>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">Estado de la Solicitud</p>
            <span class="inline-flex items-center px-4 py-2 rounded-full text-lg font-semibold border-2" [ngClass]="{
                    'bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-400 dark:border-yellow-800': request.status === BitrixRequestStatus.Pending,
                    'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800': request.status === BitrixRequestStatus.Processing,
                    'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800': request.status === BitrixRequestStatus.Success,
                    'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800': request.status === BitrixRequestStatus.Failed
                  }">
              <svg class="w-3 h-3 mr-2" fill="currentColor" viewBox="0 0 8 8">
                <circle cx="4" cy="4" r="3" />
              </svg>
              {{ getStatusName(request.status) }}
            </span>
          </div>
        </div>

        <div class="flex flex-col sm:flex-row gap-3">
          <div
            class="rounded-lg bg-gradient-to-br from-purple-50 to-white p-4 border border-purple-100 dark:from-purple-900/10 dark:to-boxdark dark:border-purple-800/30">
            <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Reintentos</p>
            <p class="text-3xl font-bold mt-1"
              [ngClass]="request.retryCount > 0 ? 'text-orange-600 dark:text-orange-400' : 'text-gray-400'">
              {{ request.retryCount }}
            </p>
            <p *ngIf="request.lastRetryDate" class="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Último: {{ formatDate(request.lastRetryDate) }}
            </p>
          </div>

          <button
            *ngIf="request.status === BitrixRequestStatus.Failed || request.status === BitrixRequestStatus.Pending"
            (click)="retryRequest()"
            class="group relative inline-flex items-center justify-center px-8 py-4 overflow-hidden font-medium text-white bg-gradient-to-br from-green-500 to-green-700 rounded-lg shadow-lg transition-all duration-300 ease-out hover:scale-105 hover:shadow-xl hover:from-green-600 hover:to-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">
            <svg class="relative mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            <span class="relative">Reprocesar Solicitud</span>
            <div
              class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transform -translate-x-full group-hover:translate-x-full transition-all duration-700">
            </div>
          </button>
        </div>
      </div>
    </div>

    <!-- Error Section (if there's any error info, regardless of status) -->
    <div *ngIf="request.errorMessage || request.failureStep"
      class="rounded-xl border-2 bg-gradient-to-br from-red-50 to-white p-6 shadow-lg dark:from-red-900/20 dark:to-boxdark"
      [ngClass]="{
           'border-red-300 dark:border-red-800': request.status === BitrixRequestStatus.Failed,
           'border-orange-300 dark:border-orange-800': request.status !== BitrixRequestStatus.Failed
         }">
      <div class="flex items-start gap-4 mb-4">
        <div class="flex h-10 w-10 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
          <svg class="h-6 w-6 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-1.964-1.333-2.732 0L3.732 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div class="flex-1">
          <h3 class="text-lg font-semibold text-red-900 dark:text-red-400 mb-2">Error en el Procesamiento</h3>

          <div class="mb-4">
            <p class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Paso donde falló:</p>
            <span
              class="inline-flex items-center px-3 py-1 rounded-lg bg-red-100 text-red-800 text-sm font-medium dark:bg-red-900/30 dark:text-red-400">
              {{ request.failureStep || 'No especificado' }}
            </span>
          </div>

          <div *ngIf="request.errorMessage" class="mb-4">
            <p class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Mensaje de error:</p>
            <div class="p-4 bg-white rounded-lg border border-red-200 dark:bg-boxdark dark:border-red-800">
              <p class="text-sm text-red-700 dark:text-red-400">{{ request.errorMessage }}</p>
            </div>
          </div>

          <div *ngIf="!request.errorMessage && request.failureStep" class="mb-4">
            <p class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Mensaje de error:</p>
            <div class="p-4 bg-white rounded-lg border border-orange-200 dark:bg-boxdark dark:border-orange-800">
              <p class="text-sm text-orange-700 dark:text-orange-400">
                El procesamiento falló en el paso "{{ request.failureStep }}", pero no se registró un mensaje de error
                detallado.
                Esto puede indicar que la solicitud fue interrumpida antes de completar el guardado del error.
              </p>
            </div>
          </div>

          <div *ngIf="request.errorDetails" class="mb-4">
            <div class="flex items-center justify-between mb-2">
              <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Detalles técnicos:</p>
              <button (click)="copyToClipboard(request.errorDetails)"
                class="inline-flex items-center px-3 py-1 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors dark:bg-boxdark dark:border-strokedark dark:text-gray-300 dark:hover:bg-gray-800">
                <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
                Copiar
              </button>
            </div>
            <pre
              class="p-4 bg-gray-900 text-gray-100 rounded-lg text-xs overflow-x-auto max-h-64 border border-gray-700">{{ request.errorDetails }}</pre>
          </div>

          <div
            class="p-4 bg-yellow-50 border border-yellow-200 rounded-lg dark:bg-yellow-900/10 dark:border-yellow-800/30">
            <div class="flex items-start">
              <svg class="h-5 w-5 text-yellow-600 dark:text-yellow-400 mt-0.5 mr-2" fill="none" stroke="currentColor"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div>
                <p class="text-sm font-medium text-yellow-800 dark:text-yellow-400">Recomendación</p>
                <p class="text-sm text-yellow-700 dark:text-yellow-500 mt-1">
                  Revise los datos en Bitrix, corrija el problema identificado (especialmente el campo <strong>{{
                    request.failureStep }}</strong>) y use el botón "Reprocesar Solicitud" para intentar nuevamente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Processing Logs -->
    <div *ngIf="processingLogs && processingLogs.length > 0"
      class="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div class="border-b border-stroke px-6 py-4 dark:border-strokedark">
        <div class="flex items-center justify-between">
          <h3 class="font-semibold text-gray-900 dark:text-white flex items-center">
            <svg class="mr-2 h-5 w-5 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
            </svg>
            Logs de Procesamiento
            <span
              class="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400">
              {{ processingLogs.length }} entradas
            </span>
          </h3>
          <button (click)="toggleProcessingLogs()"
            class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-indigo-700 bg-indigo-100 rounded-lg hover:bg-indigo-200 transition-colors dark:bg-indigo-900/30 dark:text-indigo-400 dark:hover:bg-indigo-900/50">
            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                [attr.d]="showProcessingLogs ? 'M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21' : 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'" />
            </svg>
            {{ showProcessingLogs ? 'Ocultar' : 'Mostrar' }}
          </button>
        </div>
        <!-- Log level summary -->
        <div class="flex gap-3 mt-2">
          <span *ngIf="getLogCountByLevel('INF') > 0"
            class="inline-flex items-center text-xs text-blue-600 dark:text-blue-400">
            <span class="w-2 h-2 rounded-full bg-blue-500 mr-1"></span>
            {{ getLogCountByLevel('INF') }} Info
          </span>
          <span *ngIf="getLogCountByLevel('WRN') > 0"
            class="inline-flex items-center text-xs text-yellow-600 dark:text-yellow-400">
            <span class="w-2 h-2 rounded-full bg-yellow-500 mr-1"></span>
            {{ getLogCountByLevel('WRN') }} Advertencias
          </span>
          <span *ngIf="getLogCountByLevel('ERR') > 0"
            class="inline-flex items-center text-xs text-red-600 dark:text-red-400">
            <span class="w-2 h-2 rounded-full bg-red-500 mr-1"></span>
            {{ getLogCountByLevel('ERR') }} Errores
          </span>
        </div>
      </div>
      <div *ngIf="showProcessingLogs" class="p-6">
        <div class="space-y-2">
          <div *ngFor="let log of processingLogs; let i = index"
            class="flex items-start gap-3 p-3 rounded-lg border transition-colors"
            [ngClass]="getLogRowClass(log.Level)">
            <!-- Log Level Icon -->
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5" [ngClass]="getLogLevelIconColor(log.Level)" fill="none" stroke="currentColor"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  [attr.d]="getLogLevelIcon(log.Level)" />
              </svg>
            </div>
            <!-- Log Content -->
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 mb-1">
                <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
                  [ngClass]="getLogLevelClass(log.Level)">
                  {{ log.Level }}
                </span>
                <span *ngIf="log.Code"
                  class="inline-flex items-center px-2 py-0.5 rounded text-xs font-mono bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300">
                  {{ log.Code }}
                </span>
                <span class="text-xs text-gray-500 dark:text-gray-400">
                  {{ formatLogTimestamp(log.Timestamp) }}
                </span>
              </div>
              <p class="text-sm text-gray-700 dark:text-gray-300 break-words">
                {{ log.Message }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Info Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- General Info -->
      <div class="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div class="border-b border-stroke px-6 py-4 dark:border-strokedark">
          <h3 class="font-semibold text-gray-900 dark:text-white flex items-center">
            <svg class="mr-2 h-5 w-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Información General
          </h3>
        </div>
        <div class="p-6 space-y-4">
          <div class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Lead ID:</span>
            <span class="text-sm font-semibold text-gray-900 dark:text-white font-mono">{{ request.leadId }}</span>
          </div>
          <div class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Fecha Solicitud:</span>
            <span class="text-sm text-gray-900 dark:text-white">{{ formatDate(request.requestDate) }}</span>
          </div>
          <div class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Fecha Procesamiento:</span>
            <span class="text-sm text-gray-900 dark:text-white">{{ formatDate(request.processedDate) }}</span>
          </div>
          <div class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Proyecto:</span>
            <span *ngIf="request.projectMnemonic"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400">
              {{ request.projectMnemonic }}
            </span>
            <span *ngIf="!request.projectMnemonic" class="text-sm text-gray-400">-</span>
          </div>
          <div *ngIf="request.processingTimeMs" class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Tiempo Procesamiento:</span>
            <span class="text-sm text-gray-900 dark:text-white">{{ request.processingTimeMs }}ms</span>
          </div>
          <div *ngIf="request.completedStep" class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Paso Completado:</span>
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400">
              {{ request.completedStep }}
            </span>
          </div>
        </div>
      </div>

      <!-- Participant Info -->
      <div class="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div class="border-b border-stroke px-6 py-4 dark:border-strokedark">
          <h3 class="font-semibold text-gray-900 dark:text-white flex items-center">
            <svg class="mr-2 h-5 w-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            Información del Participante
          </h3>
        </div>
        <div class="p-6 space-y-4">
          <div class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Nombre:</span>
            <span class="text-sm text-gray-900 dark:text-white">{{ request.participantName || '-' }}</span>
          </div>
          <div class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Email:</span>
            <span class="text-sm text-gray-900 dark:text-white">{{ request.participantEmail || '-' }}</span>
          </div>
          <div class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Participant ID:</span>
            <div class="flex items-center gap-2">
              <span *ngIf="request.participantId" class="text-sm text-gray-900 dark:text-white">{{ request.participantId
                }}</span>
              <button *ngIf="request.participantId" (click)="viewParticipant()"
                class="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded hover:bg-blue-200 transition-colors dark:bg-blue-900/30 dark:text-blue-400 dark:hover:bg-blue-900/50">
                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                Ver
              </button>
              <span *ngIf="!request.participantId" class="text-sm text-gray-400">-</span>
            </div>
          </div>
          <div class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Enrollment ID:</span>
            <div class="flex items-center gap-2">
              <span *ngIf="request.enrollmentId" class="text-sm text-gray-900 dark:text-white">{{ request.enrollmentId
                }}</span>
              <button *ngIf="request.enrollmentId" (click)="viewEnrollment()"
                class="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded hover:bg-blue-200 transition-colors dark:bg-blue-900/30 dark:text-blue-400 dark:hover:bg-blue-900/50">
                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                Ver
              </button>
              <span *ngIf="!request.enrollmentId" class="text-sm text-gray-400">-</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Outbound Info (solo para peticiones de salida) -->
    <div *ngIf="isOutbound()"
      class="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div class="border-b border-stroke px-6 py-4 dark:border-strokedark">
        <h3 class="font-semibold text-gray-900 dark:text-white flex items-center">
          <svg class="mr-2 h-5 w-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
          Información de Petición Saliente (Outbound)
        </h3>
      </div>
      <div class="p-6 space-y-4">
        <div class="flex items-start">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Acción:</span>
          <span *ngIf="request.outboundAction"
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400">
            {{ request.outboundAction }}
          </span>
          <span *ngIf="!request.outboundAction" class="text-sm text-gray-400">-</span>
        </div>
        <div class="flex items-start">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-40">Status ID Enviado:</span>
          <span *ngIf="request.outboundStatusId" class="text-sm font-mono text-gray-900 dark:text-white">{{
            request.outboundStatusId }}</span>
          <span *ngIf="!request.outboundStatusId" class="text-sm text-gray-400">-</span>
        </div>

        <!-- Outbound Response -->
        <div *ngIf="request.outboundResponse">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400">Respuesta de Bitrix:</span>
            <div class="flex gap-2">
              <button (click)="copyToClipboard(outboundResponseFormatted)"
                class="inline-flex items-center px-2 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600">
                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
                Copiar
              </button>
              <button (click)="toggleOutboundResponse()"
                class="inline-flex items-center px-2 py-1 text-xs font-medium text-purple-700 bg-purple-100 rounded-lg hover:bg-purple-200 transition-colors dark:bg-purple-900/30 dark:text-purple-400 dark:hover:bg-purple-900/50">
                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    [attr.d]="showOutboundResponse ? 'M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21' : 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'" />
                </svg>
                {{ showOutboundResponse ? 'Ocultar' : 'Mostrar' }}
              </button>
            </div>
          </div>
          <pre *ngIf="showOutboundResponse"
            class="mt-2 p-4 bg-gray-900 text-gray-100 rounded-lg text-xs overflow-x-auto max-h-64 border border-gray-700">{{ outboundResponseFormatted }}</pre>
        </div>
      </div>
    </div>

    <!-- HTTP Request Info -->
    <div *ngIf="request.httpRequestInfo"
      class="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div class="border-b border-stroke px-6 py-4 dark:border-strokedark">
        <div class="flex items-center justify-between">
          <h3 class="font-semibold text-gray-900 dark:text-white flex items-center">
            <svg class="mr-2 h-5 w-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9" />
            </svg>
            Información de la Petición HTTP
          </h3>
          <div class="flex gap-2">
            <button (click)="copyToClipboard(httpRequestInfoFormatted)"
              class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600">
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              Copiar
            </button>
            <button (click)="toggleHttpRequestInfo()"
              class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-blue-700 bg-blue-100 rounded-lg hover:bg-blue-200 transition-colors dark:bg-blue-900/30 dark:text-blue-400 dark:hover:bg-blue-900/50">
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  [attr.d]="showHttpRequestInfo ? 'M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21' : 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'" />
              </svg>
              {{ showHttpRequestInfo ? 'Ocultar' : 'Mostrar' }}
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="showHttpRequestInfo" class="p-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div *ngIf="httpRequestData?.remoteIpAddress" class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-24">IP:</span>
            <span class="text-sm text-gray-900 dark:text-white font-mono">{{ httpRequestData.remoteIpAddress }}</span>
          </div>
          <div *ngIf="httpRequestData?.userAgent" class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-24">User-Agent:</span>
            <span class="text-sm text-gray-900 dark:text-white break-all">{{ httpRequestData.userAgent }}</span>
          </div>
          <div *ngIf="httpRequestData?.method" class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-24">Método:</span>
            <span
              class="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400">
              {{ httpRequestData.method }}
            </span>
          </div>
          <div *ngIf="httpRequestData?.timestamp" class="flex items-start">
            <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-24">Timestamp:</span>
            <span class="text-sm text-gray-900 dark:text-white">{{ formatDate(httpRequestData.timestamp) }}</span>
          </div>
        </div>
        <div class="mb-4">
          <p class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Headers HTTP:</p>
          <div class="p-4 bg-gray-50 rounded-lg border dark:bg-gray-800 dark:border-gray-700 max-h-48 overflow-y-auto">
            <div *ngFor="let header of getHttpHeaders()"
              class="flex items-start py-1 border-b border-gray-200 dark:border-gray-700 last:border-b-0">
              <span class="text-xs font-medium text-gray-600 dark:text-gray-400 w-32 flex-shrink-0">{{ header.key
                }}:</span>
              <span class="text-xs text-gray-900 dark:text-white break-all ml-2">{{ header.value }}</span>
            </div>
          </div>
        </div>
        <div>
          <p class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Datos completos (JSON):</p>
          <pre
            class="p-4 bg-gray-900 text-gray-100 rounded-lg text-xs overflow-x-auto max-h-64 border border-gray-700">{{ httpRequestInfoFormatted }}</pre>
        </div>
      </div>
    </div>

    <!-- Raw Lead Data -->
    <div *ngIf="request.rawLeadData"
      class="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div class="border-b border-stroke px-6 py-4 dark:border-strokedark">
        <div class="flex items-center justify-between">
          <h3 class="font-semibold text-gray-900 dark:text-white flex items-center">
            <svg class="mr-2 h-5 w-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
            </svg>
            Datos del Lead (JSON)
          </h3>
          <div class="flex gap-2">
            <button (click)="copyToClipboard(rawLeadDataFormatted)"
              class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600">
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              Copiar
            </button>
            <button (click)="toggleRawData()"
              class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-purple-700 bg-purple-100 rounded-lg hover:bg-purple-200 transition-colors dark:bg-purple-900/30 dark:text-purple-400 dark:hover:bg-purple-900/50">
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  [attr.d]="showRawData ? 'M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21' : 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'" />
              </svg>
              {{ showRawData ? 'Ocultar' : 'Mostrar' }}
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="showRawData" class="p-6">
        <pre
          class="p-4 bg-gray-900 text-gray-100 rounded-lg text-xs overflow-x-auto max-h-96 border border-gray-700">{{ rawLeadDataFormatted }}</pre>
      </div>
    </div>

    <!-- Audit Info -->
    <div class="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div class="border-b border-stroke px-6 py-4 dark:border-strokedark">
        <h3 class="font-semibold text-gray-900 dark:text-white flex items-center">
          <svg class="mr-2 h-5 w-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Auditoría
        </h3>
      </div>
      <div class="p-6 space-y-4">
        <div class="flex items-start">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-32">Creado:</span>
          <div class="flex-1">
            <p class="text-sm text-gray-900 dark:text-white">{{ formatDate(request.createdAt) }}</p>
            <p *ngIf="request.createdBy" class="text-xs text-gray-500 dark:text-gray-400 mt-1">por {{ request.createdBy
              }}</p>
          </div>
        </div>
        <div class="flex items-start">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400 w-32">Actualizado:</span>
          <div class="flex-1">
            <p class="text-sm text-gray-900 dark:text-white">{{ formatDate(request.updatedAt) }}</p>
            <p *ngIf="request.updatedBy" class="text-xs text-gray-500 dark:text-gray-400 mt-1">por {{ request.updatedBy
              }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>